import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { ProductStatus } from '../../../entity/Product'
import { getUrlWithVersion } from '../../../api/api'

export const changeProductStatus = createAsyncThunk<
    void,
    { guid: string; newStatus: ProductStatus },
    ThunkConfig<string>
>('productsSlice/changeProductStatus', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid, newStatus } = args

    try {
        await api.post(getUrlWithVersion(`/products/${guid}/status`), {
            status: newStatus,
        })
        throwSuccessMessage('Success!')
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to change product status')
    }
})
